module.exports = __webpack_public_path__ + "teqbahn-assets/media/37.8db1f717.png";